import { Box, Grid, Typography } from '@mui/material';

/** TRANSLATION */
import { useTranslation } from 'react-i18next';

/** UTILS */
import { checkPackage, numberFormat, toBuddhistYear } from 'utils/app.utils';

/** CONSTANTS */
import { PACKAGE_ADDONS } from 'constants/package';
import { colors } from 'constants/theme';
import _ from 'lodash';
import moment from 'moment';
import { memo, useMemo } from 'react';
import { useSummaryReceiptController } from './hooksTemp/useSummaryReceiptController';
import { SummaryReceiptType } from './types/types';



function SummaryReceipt(props: SummaryReceiptType) {
  const { systemConfig: { isUseCrm } } = props

  const { t } = useTranslation()
  const {
    getTreatmentData
  } = useSummaryReceiptController(props)


  const totalOutstanding = useMemo(() =>
    props.objPayment.overdue,
    [props.objPayment]
  )


  const renderListOrder = (treatment: any, index: any) => {
    const { itemName, price, paid } = getTreatmentData(treatment, index);
    return (
      <Grid container spacing={1} className={'my-0'} key={index}>
        <Grid item sm={6} sx={{ flex: 1 }} className={'overflow-hidden'}>
          <Typography className='pl-2' sx={{ fontWeight: 100 }}>{itemName}</Typography>
        </Grid>
        <Grid item sm={3} className={``}>
          <Typography className='text-right' sx={{ fontWeight: 100 }}>{numberFormat(price)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Grid>
        <Grid item sm={3} className={``}>
          <Typography className='text-right' sx={{ fontWeight: 100 }}>{numberFormat(paid)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      <Box className='px-md-2 px-xl-3 mb-3'>
        <Box className='d-flex justify-content-between'>
          <Typography sx={{ fontSize: 18, fontWeight: 500 }}>{props.patient.branchCnNumber ? `${props.patient.branchCnNumber}` : ''} <span className='pl-3 pr-2'>{t('PAYMENT.FORM_PAYMENT.NAME_PATIENT')}</span>{props.patient.firstname} {props.patient.lastname}</Typography>
          <Typography sx={{ fontSize: 18, fontWeight: 500 }}>{toBuddhistYear(moment(props.date), 'DD/MM/YYYY')}</Typography>
        </Box>
      </Box>
      <Box className='px-md-2 px-xl-3 mb-3'>
        <Grid container spacing={2} className={'my-0'}>
          <Grid item sm={6} sx={{ flex: 1 }} className={'overflow-hidden'}>
            <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TABLE.TREATMENT')}</Typography>
          </Grid>
          <Grid item sm={3} className={``}>
            <Typography className='text-right' sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TABLE.PRICE_LIST')}</Typography>
          </Grid>
          <Grid item sm={3} className={``} >
            <Typography className='text-right' sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.TABLE.TOTAL_PAY')}</Typography>
          </Grid>
        </Grid>
        {_.map(props.listOrder, (treatment: any, index: any) => renderListOrder(treatment, index))}
      </Box>
      <Box className='px-md-2 px-xl-3 pb-3 mb-3' sx={{ borderBottom: `2px solid ${colors.textLightGray}` }}>
        {isUseCrm &&
          <>
            <Box className='d-flex align-items-center justify-content-between pt-1'>
              <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_NET_PROMOTION')}</Typography>
              <Typography sx={{ fontWeight: 500 }}>{numberFormat(props.objPayment.discountPromotion)} {t('CURRENCY_CHANGE.TH')}</Typography>
            </Box>
            <Box className='d-flex align-items-center justify-content-between pt-1'>
              <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_NET_VOUCHER')}</Typography>
              <Typography sx={{ fontWeight: 500 }}>{numberFormat(props.objPayment.discountVoucher)} {t('CURRENCY_CHANGE.TH')}</Typography>
            </Box>
          </>
        }
        <Box className='d-flex align-items-center justify-content-between pt-1'>
          <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_TREATMENT_DISCOUNT')}</Typography>
          <Typography sx={{ fontWeight: 500 }}>{numberFormat(props.objPayment.discountTreatmentRight)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Box>
        {checkPackage(PACKAGE_ADDONS.ADDON_ADVANCE) && (
          <Box className='d-flex align-items-center justify-content-between pt-1'>
            <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_ADVANCE_BALANCE')}</Typography>
            <Typography sx={{ fontWeight: 500 }}>{numberFormat(props.objPayment.advance)} {t('CURRENCY_CHANGE.TH')}</Typography>
          </Box>
        )}
        <Box className='d-flex align-items-center justify-content-between pt-1'>
          <Typography sx={{ fontWeight: 600 }}>{t('PAYMENT.FORM_PAYMENT.SUM_NET_BALANCE')}</Typography>
          <Typography sx={{ fontWeight: 600 }}>{numberFormat(props.objPayment.balance + props.objPayment?.approvedArrear)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Box>
      </Box>
      <Box className='px-md-2 px-xl-3 mb-3'>
        <Box className='d-flex align-items-center justify-content-between pt-1'>
          <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_NET_INCOME')}</Typography>
          <Typography sx={{ fontWeight: 500 }}>{numberFormat(props.objPayment.amountReceipt)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Box>
        <Box className='d-flex align-items-center justify-content-between pt-1'>
          <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_NET_CHANGE')}</Typography>
          <Typography sx={{ fontWeight: 500 }}>{numberFormat(props.objPayment.amountChange)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Box>
        <Box className='d-flex align-items-center justify-content-between pt-1'>
          <Typography sx={{ fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.SUM_NET_OUT_STANDING')}</Typography>
          <Typography sx={{ fontWeight: 500 }}>{numberFormat(totalOutstanding)} {t('CURRENCY_CHANGE.TH')}</Typography>
        </Box>
      </Box>
    </>
  )
}

export default memo(SummaryReceipt)


